import React, { useContext, useRef, useMemo, useImperativeHandle, forwardRef } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
import { Listbox } from '../../lab/Listbox';
import { useIsMobileView } from '@front10/utils';
import RadioButtonGroup from '../../elements/RadioButtonGroup';
import Box from '../../elements/Box';
import Text from '../../elements/Text';

const RedemptionUnitFilter = (props, ref) => {
  const {
    value,
    options = [
      { label: 'cmp-cash-label', value: 'CASH' },
      { label: 'cmp-loyalty-unit-label', value: 'MILES' }
    ],
    disabled,
    isMobile = false,
    onChange,
    showTitle,
    filterButtonIconProps,
    mobileOrientation = 'horizontal', // horizontal or vertical
    containerStyle,
    titleStyle = {
      fontWeight: 'bold'
    },
    itemsContainerStyle = {},
    itemsStyles = {}
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const title = translate('cmp-redemption-unit', 'Redemption unit');

  const redemptionUnitOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(option.label)
    }));
  }, [options, translate]);

  let mobileView = useIsMobileView();
  if (isMobile) {
    mobileView = true;
  }

  const listboxRef = useRef(null);

  const [redemptionFilter, setRedemptionFilter] = React.useState(value);

  React.useEffect(() => {
    setRedemptionFilter(value);
  }, [value]);

  useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current?.focusToggleElement();
      }
    }),
    []
  );

  const desktopLayout = (
    <Listbox
      ref={listboxRef}
      label={title}
      options={redemptionUnitOptions}
      defaultValue={value}
      forcePlaceholder={disabled}
      focusWhenIsShow={false}
      disabled={disabled}
      onChange={(value) => onChange({ value })}
      filterButtonIconProps={filterButtonIconProps}
    />
  );

  const mobileLayout = (
    <Box {...containerStyle}>
      {showTitle ? (
        <Text
          variant="text.fontSize5"
          display="flex"
          alignItems="center"
          paddingLeft="5px"
          paddingBottom="15px"
          {...titleStyle}
        >
          {title}
        </Text>
      ) : null}
      <RadioButtonGroup
        options={redemptionUnitOptions}
        defaultOption={redemptionFilter}
        onChange={(newRedemptionUnit) => {
          setRedemptionFilter(newRedemptionUnit);
          props.onChange({ value: newRedemptionUnit });
        }}
        orientation={mobileOrientation}
        itemsStyle={itemsStyles}
        itemsContainerStyle={itemsContainerStyle}
      />
    </Box>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>
        {!mobileView ? desktopLayout : mobileLayout}
      </ThemeProvider>
    </EmotionCache>
  );
};

export default forwardRef(RedemptionUnitFilter);
